// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
// import DxInputSearch from "../components/inputSearch.js";
import jwt_decode from "jwt-decode";
import * as React from "react";
import YZhanWeather from "yzhanweather";
import AutumnAnimation from "../components/autumnAnimation";
import Footer from "../components/footer";
import LeftShortcut from "../components/leftShortcut";
import Navigate from "../components/navigate";
import RightAppCard from "../components/rightAppCard";
import SummerAnimation from "../components/summerAnimation";
import { LoginConfig } from "../services/config/login-config.js";
import ProfileInfoService from "../services/profileInfo.js";
import SystemInfoService from "../services/systemInfo.js";
import "../style/Loading.css";

class Platefrom extends React.Component {
  constructor(props) {
    super(props);
    this.getSystemInfo = this.listSystemInfos.bind(this);
    this.getBasicInfo = this.getBasicInfo.bind(this);
    this.filterSites = this.filterSites.bind(this);
    this.state = {
      error: null,
      isLoaded: false,
      keyword: "",
      items: [],
      profileInfo: {},
      theme: {}
    };
    const loginPageUrl = LoginConfig.indexPageURL.replace("/index", "/login");
    const checkTokenExpired = () => {
      const accessToken = window.localStorage.getItem("accessToken");
      if (!accessToken) {
        window.location.href = loginPageUrl;
        return;
      }
      const payload = jwt_decode(accessToken);
      const expired = payload.exp * 1_000 < new Date().getTime();
      if (expired) {
        window.location.href = loginPageUrl;
      }
    };
    checkTokenExpired();

    window.addEventListener("focus", checkTokenExpired);
  }

  async getSeason() {
    const now = new Date;
    const nowMonth = now.getMonth() + 1;
    let season = new URLSearchParams(window.location.search).get("season");
    const SeasonThemeConfig = {
      Spring: {
        seasonBg: "spring/spring-bg-1",
        seasonThemeImg: "spring/spring-deer"
      },
      Summer: {
        seasonBg: "summer/seaBG",
        seasonThemeImg: "summer/beachGirl"
      },
      Autumn: {
        seasonBg: "autumn/6689",
        seasonThemeImg: "autumn/autumnCloudManCake"
      },
      Winter: {
        seasonBg: "winter/winter-footer-tree",
        seasonThemeImg: "winter/snow-man"
      }
    };
    if (!season) {
      if (nowMonth < 4) {
        // Spring
        season = "Spring";
      } else if (nowMonth > 3 && nowMonth < 7) {
        // Summer
        season = "Summer";
      } else if (nowMonth > 6 && nowMonth < 10) {
        // Autumn
        season = "Autumn";
      } else {
        // Winter
        season = "Winter";
      }
    }
    const reponse = {
      season: season,
      seasonBg: SeasonThemeConfig[season].seasonBg,
      seasonThemeImg: SeasonThemeConfig[season].seasonThemeImg
    };

    this.setState({theme: reponse});
    return season;
  }

  async listSystemInfos(i18nLan) {
    return SystemInfoService.fetchSystemInfos({ lang: i18nLan })
      .then(({ data }) => {
        // console.log(res.data.data, 'api success');
        const sites = data.data.map((item) => {
          item.visible = true;
          return item;
        });
        this.setState({
          isLoaded: true,
          items: sites
        });
      })
      .catch((err) => {
        this.setState({
          isLoaded: true,
          err
        });
      });
  }

  async getBasicInfo(i18nLan) {
    ProfileInfoService.fetchProfileInfo({ lang: i18nLan })
      .then(({ data }) => {
        this.setState({
          profileInfo: data.data
        });
      })
      .catch((err) => {
        this.setState({
          isLoaded: true,
          err
        });
      });
  }

  async componentDidMount() {
    const season = await this.getSeason();
    import(`../style/${season}.css`);
    let i18nLan = window.localStorage.getItem("i18nextLng");
    {
      await this.listSystemInfos(i18nLan);
      await this.getBasicInfo(i18nLan);
    }
    if ( season === "Spring" || season === "Winter") {
      const yzhanweather = new YZhanWeather();
      yzhanweather.run(season === "Spring" ? "sakura" : "snow");
    }
  }

  filterSites(e) {
    const keyword = e.target.value;
    this.setState({ keyword });
    console.log(keyword);
    this.state.items.forEach((item) => {
      item.visible = `${item.name}: ${item.description}`.includes(keyword);
    });
  }

  isBirthday(birthday) {
    const today = new Date();
    const birthday_in_datetime_type = new Date(Date.parse(birthday));
    const isTodayBirthday = 
      birthday_in_datetime_type.getDate() === today.getDate() && 
      birthday_in_datetime_type.getMonth() + 1 === today.getMonth() + 1 && 
      birthday_in_datetime_type.getFullYear() === today.getFullYear();
    
    return isTodayBirthday;
  }
  
  render() {
    if (!this.state.isLoaded) {
      return (
        // <>
        //   <div className="center">
        //     { Array(10).fill({}).map((_, index) => <div key={index} className="wave"></div>) }
        //   </div>
        // </>
        <>
          <div className="loading-wrapper">
            <ul>
              { Array(25).fill({}).map((_, index) => <li key={index}></li>) }
            </ul>
          </div>
        </>
      );
    }
    return (
      <>
        <div className="wrapper">
          <div className="content">
            <Navigate 
              profileInfo={this.state.profileInfo} 
              isBirthday={this.isBirthday(this.state.profileInfo.birthday)}
            ></Navigate>
            <div className="  grid grid-cols-12 px-2  sm:grid-flow-row md:grid-flow-row laptop:grid-flow-row lg:grid-flow-col  gap-2 mx-auto mt-10  ">
              <div className="light-bg col-start-2 col-end-5 lg:col-start-2 xl:col-start-3 lg:col-end-6 min-h-full mx-2 hidden lg:block">
                <LeftShortcut
                  profileInfo={this.state.profileInfo}
                  isBirthday={this.isBirthday(this.state.profileInfo.birthday)}
                  items={this.state.items}
                />
              </div>
              <div className="light-bg col-start-2 col-end-12 sm:col-start-2 md:col-start-3 lg:col-start-6 lg:col-end-12 xl:col-end-11 xl:w-[768px] 2xl:w-[1024px] block  min-h-full  ">
                {/* 這邊放卡片元件 */}

                <RightAppCard
                  items={this.state.items}
                  season={this.state.theme.season}
                  seasonThemeImg={this.state.theme.seasonThemeImg}
                  className=" mx-auto px-10 "
                />
                {/* <DxInputSearch
                    className="bg-white h-12 mb-10 py-3   outline-none sm:col-span-10 md:col-span-9 col-span-7  inline-flex border border-gray-300 text-gray-900 text-sm hover:border-sky-200 focus:border-sky-200 focus-visible:border-sky-200   block  p-2.5  "
                    shsize="md"
                    size="w-40"
                    value={this.state.keyword}
                    onChange={this.filterSites}
                /> */}
              </div>
            </div>
            <div>
              { this.state.theme.seasonBg &&
                <img
                  src={require(`../assets/${this.state.theme.seasonBg}.png`)}
                  alt="seasonBg"
                  className="block w-100 mx-auto mb-3 footer"
                />
              }
              {/* Season Animation */}
              { this.state.theme.season === "Summer" ? (
                <SummerAnimation/>
              ) : this.state.theme.season === "Autumn" ? (
                <AutumnAnimation />
              ) : null }
            </div>
          </div>
          <Footer className={"text-center md:text-right"} />
        </div>
      </>
    );
  }
}

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default Platefrom;
